import { render } from "./SavedTablesListStatusColumn.vue?vue&type=template&id=0ab286b6"
import script from "./SavedTablesListStatusColumn.vue?vue&type=script&lang=js"
export * from "./SavedTablesListStatusColumn.vue?vue&type=script&lang=js"

import "./SavedTablesListStatusColumn.vue?vue&type=style&index=0&id=0ab286b6&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__